<template>
  <div>
    <!--高级配置-->
    <div class="Table-Con">
      <el-form ref="ruleForm" label-width="240px" class="demo-ruleForm">
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.enable')}：`" prop="name">
          <el-checkbox v-model="data.enabled"></el-checkbox>
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.debug')}：`" prop="name">
          <el-checkbox v-model="data.enable_debug"></el-checkbox>
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.TCPSurvivalFreeTime')}：`" prop="name">
          <el-row>
            <el-col :span="24">
              <el-input size="mini" class="Form-Input-Width" v-model="data.tcp_keepalive_time" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="serverTips">{{$t('lang.smartlink.seconds')}}</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.TCPSurvivalDetectionInterval')}：`" prop="name">
          <el-row>
            <el-col :span="24">
              <el-input
                size="mini"
                class="Form-Input-Width"
                v-model="data.tcp_keepalive_interval"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="serverTips">{{$t('lang.smartlink.seconds')}}</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.TCPSurvivalDetectionMax')}：`" prop="name">
          <el-input
            size="mini"
            class="Form-Input-Width"
            v-model="data.tcp_keepalive_probes"
          />
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.saveLogNumber')}：`" prop="name">
          <el-input size="mini" class="Form-Input-Width" v-model="data.log_file_num" />
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.logSize')}：`" prop="name">
          <el-row>
            <el-col :span="24">
              <el-input size="mini" class="Form-Input-Width" v-model="data.log_file_size" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="serverTips">KB</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.logPriority')}：`" prop="name">
          <el-select
            v-model="data.log_priority"
            class="Form-Input-Width"
            size="mini"
          >
            <el-option
              v-for="item in LogPriorityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="Form-Item" :label="`${$t('lang.smartlink.log')}：`">
          <el-button size="small" type="danger" @click="downloadLog"> {{$t('lang.smartlink.download')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
     <el-button type="danger" size="mini" class="Config-Buttom" @click="updateService">
        {{$t('lang.ConfigSetting.SaveApply')}}
      </el-button>
  </div>
</template>
<script>
import { updateConfig, getLog } from "@/api/configurationlist";
import { cloneDeep, isEqual } from "lodash";

export default {
  props: ["deviceDid", "deviceSn",'data', 'originalServer','nms'],
  data() {
    return {
      //日志优先级选项
      LogPriorityList:[
          {value:'8',label: this.$t('lang.smartlink.debug')},
          {value:'7',label: this.$t('lang.smartlink.info')},
          {value:'6',label: this.$t('lang.smartlink.notice')},
          {value:'5',label: this.$t('lang.smartlink.alarm')},
          {value:'4',label: this.$t('lang.smartlink.error')},
          {value:'3',label: this.$t('lang.smartlink.deadly')},
          {value:'2',label: this.$t('lang.smartlink.alert')},
          {value:'1',label: this.$t('lang.smartlink.emergency')}
      ],
    }
  },
  watch: {
    server: {
      immediate: true,
      handler: function() {
        this.data.enabled = this.data.enabled == '1' ? true : false
        this.data.enable_debug = this.data.enable_debug == '1' ? true : false
      }
    }
  },
  computed: {
    server() {
      return this.data
    }
  },
  methods: {
    updateService() {
      if(!isEqual(this.originalServer, this.data)) {
        let copyData = cloneDeep(this.data)
        copyData.enabled = copyData.enabled == false ? "" : "1";
        copyData.enable_debug = copyData.enable_debug == false ? "" : "1";
        updateConfig(this.deviceSn, this.deviceDid, [
            {
              section: "service",
              config: this.nms?"smartnms":"smartlink",
              action: 0,
              index: [0],
              server: this.nms?"smartnms":"smartlink",
              options: {
                ...copyData
              }
            }
          ])
          .then(res => {
            if (res.data.data.mess === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.ConfigSetting.Successfulconfiguration"),
                type: "success"
              });
              this.$emit("updateData");
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.ConfigSetting.Configurationerror"),
                type: "warning"
              });
              return;
            }
          })
          .catch(err => {});
      }
      
    },
    // 下载日志文件
    downloadLog() {
      let params = {
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: this.nms?"smartnms":"smartlink"
      }
      getLog(params).then(res => {
        const { data } = res
        // 创建Blob对象（类文件对象）
        const blob = new Blob([data])
        // let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名
        // let filename = disposition.substring(disposition.indexOf('fileName=') + 9, disposition.length)
        if('download' in document.createElement('a')) { // 非IE下载
          // 创建隐藏下载超链接
          const elink = document.createElement('a')
          // 使用超链接的download属性下载文件
          elink.download = '日志文件'
          elink.style.display = 'none'
          // 使用Blob创建一个指向类型化数组的URL
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          // 自定点击超链接
          elink.click()
          // 释放URL对象
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }else{ //IE10+下载
          navigator.msSaveBlob(blob, filename)
        }
      }).catch((err) => {
        this.$message.error(this.$t("lang.request.smartlinkError"),)
      })
    }
  }
}
</script>
<style scoped>
.Config-Buttom {
  display: table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}
.Table-Con {
  display: flex;
  justify-content: center;
}
.Form-Input-Width {
  width:5rem;
}
.serverTips{
  color: rgb(158, 154, 154);
}
.Form-Item{
 margin-bottom: 0px;
}
</style>